import {
  Modal, ModalHeader, ModalFooter, ModalBody,
} from 'reactstrap';
import styled from 'styled-components';
import closeIcon from 'assets/img/icons/closeOrangeIcon.svg';
import { colors, fonts } from 'stylesheets';

export const ModalStyled = styled(Modal)`
  display: flex;
  border-radius: 12px;
  height: 90vh;
  justify-content: center;
  align-items: center;
  max-width: none !important;
  .modal-content {
    width: ${({ width }) => width || '640px'};
    height: ${({ height }) => height || 'auto'};
    background-color: ${({ backgroundcolor }) => backgroundcolor || 'none'};
    background-clip: ${({ backgroundclip }) => backgroundclip || 'none'};
  }
`;

export const Header = styled(ModalHeader)`
  border-bottom: ${({ borderbottomheader }) => borderbottomheader || `2px solid ${colors.greyLighter}`};
  padding: 40px 40px 20px 40px;
  height: 90px;
  h5 {
    font: ${({ fontSizeHeader }) => fontSizeHeader || 20}px 'Roboto', sans-serif;
    text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
    font-weight: ${({ boldHeader }) => (boldHeader ? 700 : 500)};
    text-align: ${({ textalingheader }) => textalingheader || 'center'};
    display: block;
    width: 100%;
    color: #F07E31;
  }
  button {
    position: absolute;
    right: ${({ modallist }) => (modallist ? '48' : '28')}px;
    top: ${({ modallist }) => (modallist ? '46' : '40')}px;
    background: url(${closeIcon}) no-repeat center;
    background-size: 14px 14px;
    &:active,
    &:focus {
      outline: none;
      border: none;
    }
    span {
      display: none;
    }
  }
`;

export const Body = styled(ModalBody)`
  background-color: #F8F8F8;
  padding: ${({ padding }) => padding || '40px 60px'};
  overflow: ${({ overflow }) => overflow || 'auto'};
  p {
    font: 14px ${fonts.secondary};
    color: ${colors.greyDark};
    text-align: center;
  }
`;

export const Footer = styled(ModalFooter)`
  height: 47px;
  padding: 0px;
  border: none;
  button {
    border: none;
    border-radius: 0px;
    height: 47px;
    width: 100%;
    background: ${colors.primary};
    font: 16px ${fonts.secondary};
    text-transform: uppercase;
    font-weight: 500;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    &:active,
    &:focus {
      outline: none;
      background: darken(${colors.primary}, 5%);
      border: none;
      box-shadow: none;
    }
  }
`;
